module.exports = __webpack_public_path__ + "static/ISO14001Cert-8c18b33b92f8e943ade6056aea569138.svg";